<section>
  <div>
    <form class="standard-form implementation-plan-form" [formGroup]="implementationPlanForm">
      <div class="small-input-header">Select Annual Implementation Plan Dates</div>
      <div class="calendar-inputs">
        <div [class]="calendarContainerClass">
          <p-calendar id="startDate"
                      [attr.disable]="!hasFlags.hasInitiatives"
                      styleClass="strategies-calendar sm-cal"
                      [formControl]="startDateField"
                      inputStyleClass="standard-input"
                      placeholder="Start Date"
                      [maxDate]="endDate"
                      [showIcon]="true"
                      (onFocus)="resetCalendarEventBlocker()"
                      (onInput)="allowCalendarBlurEvent()"
                      (onSelect)="applyStartDate($event)"
                      (onBlur)="applyStartDate($event)">
          </p-calendar>
        </div>
        <div [class]="calendarContainerClass">
          <p-calendar id="endDate"
                      [attr.disabled]="!hasFlags.hasInitiatives"
                      styleClass="strategies-calendar sm-cal"
                      [formControl]="endDateField"
                      inputStyleClass="standard-input"
                      placeholder="End Date"
                      [minDate]="startDate"
                      [showIcon]="true"
                      (onFocus)="resetCalendarEventBlocker()"
                      (onInput)="allowCalendarBlurEvent()"
                      (onSelect)="applyEndDate($event)"
                      (onBlur)="applyEndDate($event)">
          </p-calendar>
        </div>
      </div>
      <div class="error-message" *ngIf="hasEndDateWithNoStartDateAndTouched">
        <i class="fa fa-exclamation-triangle"></i>
        <span class="message-text">Please select a start date</span>
      </div>
      <div class="error-message" *ngIf="isEndDateBeforeStartDate">
        <i class="fa fa-exclamation-triangle"></i>
        <span class="message-text">Start date must be earlier than end date</span>
      </div>
      <div class="small-input-header">Select Critical Initiative</div>
      <div class="selection-container">
        <div class="input-error-wrap sans-margin">
          <div class="form-row">
            <div class="control-container">
              <app-priority-dropdown
                [singleSelection]="true"
                [showDates]="true"
                [availableOptions]="dropdownPriorityInitiatives"
                [styleClassAppends]="['default-selector-width']"
                (valueChangedCallback)="dropdownValueChanged($event)"
                defaultLabel="Select a Critical Initiative"
              ></app-priority-dropdown>
            </div>
          </div>
          <app-error-msg [control]="initiativeField"
                         [show]="initiativeField.invalid && initiativeField.touched && initiativeField.dirty">
          </app-error-msg>
        </div>
      </div>
      <button auto="implementation-view-btn" class="btn btn-primary view-btn" (click)="onViewImplementationPlan()"
              [disabled]="!hasRequiredFields">View</button>
    </form>
  </div>
  <div *ngIf="noInitiativesError" class="error-message">
    <i class="fa fa-exclamation-triangle"></i>
    <span class="message-text">There are no initiatives within the dates provided</span>
  </div>
  <div *ngIf="hasSelectedInitiative" class="initiative-content">
    <div class="title-wrapper">
      <div class="priority-title"
           [style.background-color]="selectedInitiative.priorityColor">{{selectedInitiative.priority}}</div>
    </div>
    <ul class="initiative-list styleless">
      <li [ngClass]="{'no-bottom-border': true}">
        <div class="initiative-flex" [ngClass]="{'first-one': true}"
             [style.border-left-color]="selectedInitiative.priorityColor">
          <div class="flex-right-left">
            <div>
              <h4>{{ headings.initiativeHeading }}</h4>
            </div>
            <div>
              <div class="status-container" *ngIf="selectedInitiative.status">
                <button [class]="statusButtonClass"
                        (click)="onPlanCoordinateChangeUpdateProgress()">
                  <div class="status-button-content">
                    <span>{{selectedInitiative.status}}</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div class="initiative-details">
            <div class="initiative-details-main">
              <div class="text">
                <app-edit-overlay [isEditor]="!isEditItemDisabled"
                                  (planCoordinateChange)=
                                    "onPlanCoordinateChangeCreatingObjectivesAndCriticalInitiatives()">
                  <div class="initiative-description hard-break-text">{{selectedInitiative.initiative}}</div>
                </app-edit-overlay>
              </div>
              <div class="initiative-sub-details">
                <div>
                  <span class="label"><b>{{ headings.objectiveHeading }}:</b></span>
                  <app-edit-overlay class="allow-shrink"
                                    [isEditor]="!isEditItemDisabled"
                                    (planCoordinateChange)=
                                      "onPlanCoordinateChangeCreatingObjectivesAndCriticalInitiatives()">
                    <span class="objective-title">{{selectedInitiative.objective}}</span>
                  </app-edit-overlay>
                </div>
              </div>
            </div>
            <div class="initiative-details-alt">
              <app-edit-overlay class="allow-shrink"
                                [isEditor]="!isEditItemDisabled"
                                (planCoordinateChange)="onPlanCoordinateChangeUpdateProgress()">
              <div *ngIf="selectedInitiative && selectedInitiative.comment && selectedInitiative.comment.trim() !== ''"
                   class="existing-comment-container">
                  <p class="existing-comment-value">{{selectedInitiative.comment}}</p>
              </div>
              </app-edit-overlay>
            </div>
          </div>
        </div>
        <div class="activities-container">
          <ng-container *ngIf="hasActivities">
            <div *ngFor="let activity of selectedInitiative.activities; index as activityIndex"
                 class="activity-container"
                 [ngClass]="{'last-one': isLastActivity(selectedInitiative.activities, activityIndex)}">
              <div class="flex-right-left" *ngIf="initiativeHasCitation">
                <div class="citation-outer-container">
                  <div class="citation-title"><strong>Evidence-Based Practice Citation</strong></div>
                  <div class="citation-content-container">
                    <app-edit-overlay [isEditor]="!isEditItemDisabled"
                                      (planCoordinateChange)="onPlanCoordinateChangeCreatingObjectivesAndCriticalInitiatives()">
                      <div class="citation-content"><p [innerHtml]="safeCitation"></p></div>
                    </app-edit-overlay>
                  </div>
                </div>
              </div>
              <div class="flex-right-left">
                <div>
                  <div class="activity-title"
                       [style.border-bottom-color]="selectedInitiative.priorityColor">Activity</div>
                  <app-edit-overlay [isEditor]="!isEditItemDisabled"
                                    (planCoordinateChange)="onPlanCoordinateChangeDesignImplementationPlan()">
                    <div class="activity-description">{{activity.activity}}</div>
                  </app-edit-overlay>
                </div>
              </div>
              <div class="activity-main-content">
                <div class="flex-right-left person-launch-date">
                  <div>
                    <b class="activity-sub-headers">Person Responsible:</b>
                    <div class="inline-content">
                      <app-edit-overlay class="allow-shrink"
                                        [isEditor]="!isEditItemDisabled"
                                        (planCoordinateChange)="onPlanCoordinateChangeDesignImplementationPlan()">
                        <div class="activity-sub-headers activity-sub-headers-content">
                          {{activity.personResponsible || ''}}
                        </div>
                      </app-edit-overlay>
                    </div>
                  </div>
                  <div>
                    <b class="activity-sub-headers">Launch Date:</b>
                    <div class="inline-content">
                      <app-edit-overlay class="allow-shrink"
                                        [isEditor]="!isEditItemDisabled"
                                        (planCoordinateChange)="onPlanCoordinateChangeDesignImplementationPlan()">
                        <div class="activity-sub-headers activity-sub-headers-content">
                          {{(activity.launchDate || '') | date:'MM/dd/yyyy'}}
                        </div>
                      </app-edit-overlay>
                    </div>
                  </div>
                </div>
                <div class="resources">
                  <div class="title"><b>Resource(s)</b></div>
                  <app-edit-overlay [isEditor]="!isEditItemDisabled"
                                    (planCoordinateChange)="onPlanCoordinateChangeDesignImplementationPlan()">
                    <div class="horizontal-section resources-split-row-container">
                      <div class="financial-resources-data">
                        <span class="semi-bold">Financial Resources:</span>&nbsp;{{activity.financialResource || '' }}
                      </div>
                      <div class="sources-of-funding-data hard-break-text">
                        <span class="semi-bold">Source of Funding:</span>&nbsp;{{activity.sourceOfFunding || '' }}
                      </div>
                    </div>

                    <div>
                      <div class="other-resources-data hard-break-text">
                        <span class="semi-bold">Other:</span>&nbsp;{{activity.otherResource || ''}}
                      </div>
                    </div>
                  </app-edit-overlay>
                </div>
                <div class="measures-and-targets">
                  <div class="measures no-border-left">
                    <div class="title"
                         [ngClass]="{'add-bottom-border': addTitleBorder(activity)}">Activity Measure(s)</div>
                    <app-edit-overlay class="allow-shrink"
                                      [isEditor]="!isEditItemDisabled"
                                      (planCoordinateChange)="onPlanCoordinateChangeDesignImplementationPlan()">
                      <ul class="styleless striped-list measure-target-list">
                        <ng-container *ngFor="let measure of activity.measuresAndTargets">
                          <li *ngIf="isMeasureAvailable(measure)" class="measure-list-item hard-break-text">
                            {{measure.measure || ''}}
                          </li>
                        </ng-container>
                      </ul>
                    </app-edit-overlay>
                  </div>
                  <div class="targets no-border-right">
                    <div class="title" [ngClass]="{'add-bottom-border': addTitleBorder(activity)}">Benchmark(s)</div>
                    <app-edit-overlay class="allow-shrink"
                                      [isEditor]="!isEditItemDisabled"
                                      (planCoordinateChange)="onPlanCoordinateChangeDesignImplementationPlan()">
                      <ul class="styleless striped-list measure-target-list">
                        <ng-container *ngFor="let target of activity.measuresAndTargets">
                          <li *ngIf="isTargetAvailable(target)" class="target-list-item">
                            <div class="target-outcome break-text">{{target.target || ''}}</div>
                            <div class="target-date">
                              <b>Target: {{(target.targetDate || '') | date:'MM/dd/yyyy'}}</b>
                            </div>
                          </li>
                        </ng-container>
                      </ul>
                    </app-edit-overlay>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="!hasActivities">
            <div class="activity-container"
                 [ngClass]="{'last-one': true}">
              <div class="flex-right-left" *ngIf="initiativeHasCitation">
                <div class="citation-outer-container">
                  <div class="citation-title"><strong>Evidence-Based Practice Citation</strong></div>
                  <div class="citation-content-container">
                    <app-edit-overlay [isEditor]="!isEditItemDisabled"
                                      (planCoordinateChange)="onPlanCoordinateChangeCreatingObjectivesAndCriticalInitiatives()">
                      <div class="citation-content"><p [innerHtml]="safeCitation"></p></div>
                    </app-edit-overlay>
                  </div>
                </div>
              </div>
              <div class="flex-right-left">
                <div>
                  <div class="activity-title"
                       [style.border-bottom-color]="selectedInitiative.priorityColor">Activity</div>
                  <app-edit-overlay [isEditor]="!isEditItemDisabled"
                                    (planCoordinateChange)="onPlanCoordinateChangeDesignImplementationPlan()">
                    <div class="activity-description"></div>
                  </app-edit-overlay>
                </div>
              </div>
              <div class="activity-main-content">
                <div class="flex-right-left person-launch-date">
                  <div class="person-launch-date-item">
                    <b class="activity-sub-headers">Person Responsible:</b>
                    <div class="activity-sub-headers">
                      <app-edit-overlay
                                        [isEditor]="!isEditItemDisabled"
                                        (planCoordinateChange)="onPlanCoordinateChangeDesignImplementationPlan()">
                        <div class="activity-sub-headers-content">  </div>
                      </app-edit-overlay>
                    </div>
                  </div>
                  <div class="person-launch-date-item">
                    <b class="activity-sub-headers">Launch Date:</b>
                    <div class="activity-sub-headers">
                      <app-edit-overlay
                                        [isEditor]="!isEditItemDisabled"
                                        (planCoordinateChange)="onPlanCoordinateChangeDesignImplementationPlan()">
                        <div class="activity-sub-headers-content">  </div>
                      </app-edit-overlay>
                    </div>
                  </div>
                </div>
                <div class="resources">
                  <div class="title"><b>Resource(s)</b></div>
                  <app-edit-overlay [isEditor]="!isEditItemDisabled"
                                    (planCoordinateChange)="onPlanCoordinateChangeDesignImplementationPlan()">
                    <div class="horizontal-section">
                      <div>
                        <span class="semi-bold">Financial Resources:</span>
                      </div>
                      <div>
                        <span class="semi-bold">Other:</span>
                      </div>
                    </div>
                    <div class="horizontal-section">
                      <div>
                        <span class="semi-bold">Source of Funding:</span>
                      </div>
                    </div>
                  </app-edit-overlay>
                </div>
                <div class="measures-and-targets">
                  <div class="measures no-border-left">
                    <div class="title" [ngClass]="{'add-bottom-border': true}">Measure(s)</div>
                    <app-edit-overlay class="allow-shrink"
                                      [isEditor]="!isEditItemDisabled"
                                      (planCoordinateChange)="onPlanCoordinateChangeDesignImplementationPlan()">
                      <ul class="styleless striped-list measure-target-list">
                        <li>
                        </li>
                      </ul>
                    </app-edit-overlay>
                  </div>
                  <div class="targets no-border-right">
                    <div class="title" [ngClass]="{'add-bottom-border': true}">Benchmark(s)</div>
                    <app-edit-overlay class="allow-shrink"
                                      [isEditor]="!isEditItemDisabled"
                                      (planCoordinateChange)="onPlanCoordinateChangeDesignImplementationPlan()">
                      <ul class="styleless striped-list measure-target-list">
                        <li class="target-list-item">
                          <div class="target-outcome">Benchmark:</div>
                          <div class="target-date"><b>Target:</b></div>
                        </li>
                      </ul>
                    </app-edit-overlay>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </li>
    </ul>
  </div>
</section>
